import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from 'react';

// material
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { styled } from '@mui/material/styles';
import { Stack, Container, Card, Typography, Box, Button, IconButton, Modal, Dialog, DialogContent, } from '@mui/material';
// components
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import * as FileSaver from 'file-saver';
import Moment from 'moment';
import XLSX from 'sheetjs-style';
import { useSnackbar } from 'notistack';
import Page from "../../Page";
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';

import IssueCreationDetailsPage from "../../../pages/SidebarMenus/IssueMenu/IssueCreationDetailsPage";
import StickyHeader from "../../Common/StickyHeader";
// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',

}));
const uploadStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '892px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '500px',
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
export default function IssueCreationPage() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const columns = [

        { field: 'TotalServiceMinutes', headerName: 'Row No', width: 80 },
        { field: 'ContactPerson', headerName: 'Column header' },
        { field: 'ServiceProvided', headerName: 'Error', width: 400 },

    ];
    const [pageSize, setPageSize] = useState(25);

    const [uploadModal, setUploadModal] = useState(false);
    const [requestFile, setRequestFile] = useState("");
    const [reports, setReports] = useState([]);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [errorReport, setErrorReport] = useState([]);
    const [errorModal, setErroeModal] = useState(false);
    const fileInputRef = useRef(null);
        
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '454px',
        bgcolor: 'background.paper',
        boxShadow: 24,
        height: 300,
        overflow: 'auto',   // 👈 you had auto, now hidden if you want
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
    };



    const handleNavigateBack = () => {
        navigate('/dashboard/issue/issueanalysis');
    }
    const handleCloseModal = () => {
        setUploadModal(false);
        setRequestFile("");

    }
    const handleCloseErrorModal = () => {
        setErroeModal(false);
    }
    const handleOpeneModal = () => {
        setUploadModal(true);
    }

    const handleSelectFile = (event) => {
        const selectedFile = event.target.files[0]; // only first file
        if (selectedFile) {
            setRequestFile(selectedFile);
            console.log("Selected File:", selectedFile);
        }
        event.target.value = ""; // clear input after selection
    };
    const removeFile = (index) => {
        setRequestFile(""); // Remove file by index
    };
    const handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        if (droppedFiles.length > 0) {
            setRequestFile(droppedFiles[0]);
            console.log("Dropped File:", droppedFiles[0]);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault(); // allows drop
    };

    const handleDrgaDropClick = () => {
        fileInputRef.current.click();
    };
    const formatFileSize = (bytes) => {
        if (!bytes) return "0 KB";
        const kb = bytes / 1024;
        return kb < 1024
            ? `${kb.toFixed(0)} KB`
            : `${(kb / 1024).toFixed(2)} MB`;
    };

    const getFileExtension = (filename) => {
        return filename?.substring(filename.lastIndexOf(".")) || "";
    };

    const getFileNameWithoutExt = (filename) => {
        return filename?.substring(0, filename.lastIndexOf(".")) || filename;
    };
    const exportToExcel = () => {
        URLS.downloadIssueExcelFile()
            .then((response) => {
                console.log("uplaod>>>>>>>>>>>>>", response, response.data)
                if (response.status === 200 && response.data && response.data.DownloadLink) {
                    // Create a link element
                    const link = document.createElement('a');
                    link.href = response.data?.DownloadLink;
                    link.setAttribute('download', '');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link); // Clean up after download

                    enqueueSnackbar(response.data?.Message || "Excel generated successfully.", { variant: 'success' });

                }
                else {
                    enqueueSnackbar(response.data?.Message || "Excel not found.", { variant: 'error' });
                }
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
    };

    const handleValidateAndUploadFile = () => {
        setUploadModal(false);
        setOpenSuccess(true);
        console.log("validate")
    }
    console.log("requestFile", requestFile)

    {/*rightContent={*/ }
    {/*    <Button*/ }
    {/*        variant="outlined"*/ }
    {/*        sx={{*/ }
    {/*            color: "#2E7D32",*/ }
    {/*            borderColor: "#2E7D32",*/ }
    {/*            borderWidth: "1px",*/ }
    {/*            textTransform: "none",*/ }
    {/*            mt: "3px",*/ }
    {/*            "& .MuiButton-startIcon": { mr: "2px" },*/ }
    {/*            "&:hover": {*/ }
    {/*                backgroundColor: '#2E7D32', // primary color fill*/ }
    {/*                color: "#fff",                                           // text white*/ }
    {/*                borderColor: '1px solid #2E7D32',     // match border*/ }
    {/*            },*/ }
    {/*        }}*/ }
    {/*        startIcon={<FileUploadOutlinedIcon />}*/ }

    {/*        onClick={handleOpeneModal}*/ }
    {/*    >*/ }
    {/*        Upload*/ }
    {/*    </Button>*/ }
    {/*}*/ }

    return (
        <Page title="Issue Creation | tiketic" >

            <StickyHeader
                title="Issue Creation"
                onBack={handleNavigateBack}
                showButton={false} // disable default "Create Issue" button
                showBorder={false}
               
            />
            <Modal open={uploadModal} onClose={handleCloseModal}>
                <Box sx={modalStyle}>
                    <Box
                        sx={{
                            position: 'sticky',
                            top: 0,
                            backgroundColor: '#fff',
                            zIndex: 1,
                            borderBottom: '1px solid #E5E5E5',


                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '5px 16px',
                                borderBottom: '1px solid #E0E0E0',
                                backgroundColor: '#fff',
                                m: 0, // remove outer margins
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="h5" color="text.primary" fontWeight="bold">
                                    Upload Issue Template
                                </Typography>

                            </Box>
                            <IconButton onClick={handleCloseModal}  >
                                <CloseIcon width={25} height={25} />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            overflowY: 'auto',
                            pt: 3,
                            px: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center', // center everything horizontally
                            gap: 3, // spacing between drag-drop box and buttons
                        }}
                    >
                        {/* Drag & Drop Box */}
                        {requestFile.length === 0 ? (

                            <Box
                                component="label"
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                                onClick={handleDrgaDropClick}
                                sx={{
                                    border: '2px solid transparent',
                                    borderImageSource:
                                        'url("data:image/svg+xml,%3csvg width=\'100%25\' height=\'100%25\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3crect width=\'100%25\' height=\'100%25\' fill=\'none\' rx=\'8\' ry=\'8\' stroke=\'%23ccc\' stroke-width=\'2\' stroke-dasharray=\'8%2c 8\'/%3e%3c/svg%3e")',
                                    borderImageSlice: '1',
                                    minHeight: "207px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#757575",
                                    cursor: "pointer",
                                    width: '398px',
                                    p: 2, // maintain padding inside drag-drop box
                                }}
                            >
                                <Box
                                    sx={{
                                        border: "1px solid #ddd",
                                        borderRadius: 2,
                                        backgroundColor: "#fff",
                                        p: 1.5,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mb: 1,
                                        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
                                        width: 57,
                                        height: 57,
                                    }}
                                >
                                    <Iconify
                                        icon="material-symbols:add-notes-outline-rounded"
                                        width={40}
                                        height={40}
                                        style={{ color: "#1a2b50" }}
                                    />
                                </Box>
                                <Typography variant="body2">Drag & drop or click to choose files</Typography>
                                {/* <Typography */}
                                {/*    variant="caption" */}
                                {/*    sx={{ */}
                                {/*        display: "flex", */}
                                {/*        alignItems: "center", */}
                                {/*        gap: 0.5 */}
                                {/*    }} */}
                                {/* > */}
                                {/*    <Iconify */}
                                {/*        icon="mdi:information-outline" */}
                                {/*        width={14} */}
                                {/*        height={14} */}
                                {/*        style={{ color: "#757575" }} */}
                                {/*    /> */}
                                {/*    Max file size: 10MB */}
                                {/* </Typography> */}
                                <input
                                    type="file"

                                    onChange={handleSelectFile}
                                    style={{ display: "none" }}
                                />
                            </Box>
                        ) : (
                            <Box sx={{ display: "flex", gap: 2 }}>
                                <Stack
                                    spacing={1}
                                    sx={{
                                        width: "398px",
                                        maxHeight: "51px",
                                        overflowY: "hidden",
                                    }}
                                >
                                    {requestFile && (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                border: "1px solid #A7A7A7",
                                                borderRadius: 1,
                                                px: 1.5,
                                                py: 0.5,
                                                backgroundColor: "#FFFF",
                                                height: "51px",
                                            }}
                                        >
                                            {/* File Info */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexGrow: 1,
                                                    overflow: "hidden",
                                                    gap: 1,
                                                }}
                                            >
                                                <Icon
                                                    icon="tabler:file-text"
                                                    width={30}
                                                    height={30}
                                                    style={{ color: "#525252" }}
                                                />

                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        noWrap
                                                        title={requestFile.name}
                                                        sx={{ fontWeight: 500 }}
                                                    >
                                                        {getFileNameWithoutExt(requestFile.name)}
                                                    </Typography>
                                                    <Typography
                                                        variant="caption"
                                                        sx={{ color: "#A7A7A7" }}
                                                    >
                                                        {getFileExtension(requestFile.name)} | {formatFileSize(requestFile.size)}
                                                    </Typography>
                                                </Box>
                                            </Box>

                                            {/* Delete Button */}
                                            <IconButton
                                                edge="end"
                                                size="small"
                                                onClick={removeFile}
                                                sx={{
                                                    color: "#E10F00",
                                                    "&:hover": {
                                                        backgroundColor: "rgba(255,23,68,0.1)",
                                                    },
                                                }}
                                            >
                                                <Icon icon="material-symbols:delete-outline" width={24} height={24} />
                                            </IconButton>
                                        </Box>
                                    )}
                                </Stack>
                            </Box>

                        )}
                        {/* Buttons */}
                        <Box
                            sx={{
                                display: 'flex',
                                gap: 2, // spacing between buttons

                            }}
                        >
                            <Button
                                variant="contained"
                                color='secondary'
                                sx={{ width: "192px", height: "40px" }}
                                onClick={exportToExcel}
                            >
                                Download Template
                            </Button>
                            <Button
                                size="medium"
                                variant="outlined"
                                disabled={!requestFile}
                                sx={{
                                    width: "192px", height: "40px", color: requestFile ? "#2E7D32" : "#9A9A9A", fontWeight: 600, borderColor: '#D1D5DB',
                                    '&:hover': {
                                        borderColor: '#D1D5DB'
                                    },
                                }}
                                onClick={handleValidateAndUploadFile}
                            >
                                Validate & Upload File
                            </Button>
                        </Box>
                    </Box>

                </Box>
            </Modal>
            <Dialog open={openSuccess} onClose={() => setOpenSuccess(false)}>
                <DialogContent sx={{ textAlign: "center", p: 3, width: "288px", height: "180px", overflow: 'hidden' }}>
                    {/* Green check circle */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            backgroundColor: "#4caf50",
                            borderRadius: "50%",
                            width: 40,
                            height: 40,
                            mx: "auto",

                        }}
                    >
                        <Icon icon="mdi:check" color="white" width={28} height={28} />
                    </Box>

                    {/* Title */}
                    <Typography variant="h5" gutterBottom sx={{ fontSize: '24px', color: '#000000' }}>
                        Success!
                    </Typography>

                    {/* Message */}
                    <Typography variant="body2" sx={{ mb: 2, color: '#888787', fontSize: '14px' }}>
                        Your File  {" "}
                        <Box component="span" sx={{ color: "#F74949", fontWeight: "bold" }}>
                            Issue Data File
                        </Box>{" "}
                        has been Uploaded successfully
                    </Typography>

                </DialogContent>
            </Dialog>
            <Modal open={errorModal} onClose={handleCloseErrorModal}>
                <Box sx={uploadStyle}>
                    <Box
                        sx={{
                            position: 'sticky',
                            top: 0,
                            backgroundColor: '#fff',
                            zIndex: 1,
                            borderBottom: '1px solid #E5E5E5',


                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '5px 16px',
                                borderBottom: '1px solid #E0E0E0',
                                backgroundColor: '#fff',
                                m: 0, // remove outer margins
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Typography variant="h5" color="text.primary" fontWeight="bold" ml={1}>
                                    Upload Issue Template
                                </Typography>

                            </Box>
                            <IconButton onClick={handleCloseErrorModal}  >
                                <CloseIcon width={25} height={25} />
                            </IconButton>
                        </Box>
                    </Box>

                    <Stack spacing={1} py={1} px={3}>
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>File Validation Result </Typography>
                        <Typography variant="body2" sx={{ mb: 2, color: '#A19F9F' }}>
                            Uploaded file of {" "}
                            <Box component="span" sx={{ color: "#0086FF", fontWeight: "bold" }}>
                                Issue Data File
                            </Box>{" "}
                            Found {4} errors that need to be fixed before importing
                        </Typography>

                    </Stack>
                    <Stack spacing={1} py={1} px={3}>

                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                                borderRadius: "10px",
                                backgroundColor: "#FFF9F9",
                                border: '1px solid #FFE0E3',
                                px: 2,
                                py: 1,
                                width: '690px',
                                height: '36px',

                            }}
                        >
                            <CancelOutlinedIcon sx={{ color: '#E63946', width: 16, height: 16 }} />
                            <Typography variant="body2" sx={{ color: '#4E4E4E' }}>Please fix the errors below before proceeding with the import. You can download the error report for reference.</Typography>

                        </Box>
                    </Stack>
                    <Stack spacing={1} py={1} px={3}>

                        <div style={{ height: '42vh', width: '100%' }}>
                            <DataGrid
                                rows={errorReport}
                                columns={columns}
                                density="compact"
                                getRowId={(row) => row.id || errorReport.indexOf(row)}
                                getRowHeight={() => 'auto'}
                                components={{ Toolbar: GridToolbar, }}
                                pagination
                                paginationMode="client"
                                rowsPerPageOptions={[25, 50, 100]}
                                pageSize={pageSize}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            />
                        </div>
                    </Stack>
                    <Box
                        sx={{
                            position: 'sticky',
                            bottom: 0,
                            borderTop: '1px solid #D1D5DB',
                            zIndex: 1,
                            padding: 2,
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 2,
                        }}
                    >
                        <Button
                            variant="outlined"
                            sx={{ width: "165px", height: "34px", borderColor: '#C6C6C6', color: '#2E7D32' }}
                            onClick={exportToExcel}
                            startIcon={<FileUploadOutlinedIcon />}

                        >
                            Upload New File
                        </Button>
                        <Button
                            size="medium"
                            variant="outlined"
                            sx={{ width: "210px", height: "34px", color: "#121212", borderColor: '#C6C6C6' }}
                            onClick={handleValidateAndUploadFile}
                            startIcon={<FileDownloadOutlinedIcon />}
                        >
                            Download Error Report
                        </Button>
                    </Box>

                </Box>
            </Modal>
            <ContentStyle>
                <IssueCreationDetailsPage />
            </ContentStyle>

        </Page>
    );
}

